import React, {Component} from 'react';

import {MenuItem} from '@pb/kit-component-menu';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './autosuggest.component.module.styl';

import type {MenuItemProps} from '@pb/kit-component-menu';
import type {ReactNode} from 'react';


const classes = hashedClasses(styles);

type NativeProps = Omit<MenuItemProps, 'children'>;

/**
 * NoResults component props
 */
export interface Props extends NativeProps {
    /**
     * The thick text that is displayed before the main message
     */
    strongText: string,

    /**
     * The text used as no result message
     */
    text: ReactNode,

}

/**
 * The `AutosuggestNoResults` component is used to show a message that no results have been found
 */
export class AutosuggestNoResults extends Component<Props> {
    static defaultProps = {
        strongText: '0 results.',
        text: 'Please check spelling or try another term.',
    };

    render() {
        const {strongText, text, ...props} = this.props;
        return (
            <MenuItem
                {...props}
                role="none"
                className={classes['autosuggest-list__no-results']}
                caption={(
                    <>
                        <strong>{strongText}</strong>&nbsp;{text}
                    </>
                )}
            />
        );
    }
}
